import { Locale } from '@models/contentful';
import { type PageState } from '@context/pageState';

export type PageStateActions =
    | { type: 'SET_IS_LIVE_PREVIEW'; isLivePreview: boolean }
    | { type: 'SET_LOCALE'; locale: string };

const PageReducer = (state: PageState, action: PageStateActions): PageState => {
    switch (action.type) {
        case 'SET_IS_LIVE_PREVIEW':
            return {
                ...state,
                isLivePreview: action.isLivePreview,
            };
        case 'SET_LOCALE':
            return {
                ...state,
                locale: action.locale as Locale,
            };
        default:
            return state;
    }
};

export default PageReducer;
